"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _creators = require("../../../../../redux/creators");

var _utils = require("../../../../../configuration/utils");

var _ResetFiltersComponent = _interopRequireDefault(require("./ResetFiltersComponent"));

var _CustomFilterComponent = _interopRequireDefault(require("./CustomFilterComponent"));

var _FilterComponent = _interopRequireDefault(require("./FilterComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FiltersListComponent = function FiltersListComponent(_ref) {
  var isAccessoriesList = _ref.isAccessoriesList,
      setFiltersParams = _ref.setFiltersParams;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    var _window, _window$DGS, _window$DGS$Scroller;

    (_window = window) === null || _window === void 0 ? void 0 : (_window$DGS = _window.DGS) === null || _window$DGS === void 0 ? void 0 : (_window$DGS$Scroller = _window$DGS.Scroller) === null || _window$DGS$Scroller === void 0 ? void 0 : _window$DGS$Scroller.getInstance().register(function (scrollTop) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          return resolve(calculateFiltersPosition(scrollTop));
        }, 300);
      });
    });
    setFilterValues();
    setTimeout(function () {
      return detectIsAutomaticFilters();
    }, 0);
    setTimeout(function () {
      return setPreselectedFilters();
    }, 100);
  }, [products]);
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var pimApi = (0, _reactRedux.useSelector)(function (state) {
    return state.productList;
  });
  var pepFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.pepFilters;
  });
  var products = (0, _reactRedux.useSelector)(function (state) {
    return state.activeProducts;
  });
  var isOpenFilters = (0, _reactRedux.useSelector)(function (state) {
    return state.openFilters;
  });
  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });
  var isIOS = /iPad|iPhone|iPod/.test(navigator.platform);

  var resetFiltersPosition = function resetFiltersPosition(scrollEl) {
    scrollEl.style.position = "relative";
    scrollEl.style.top = "auto";
    scrollEl.style.bottom = "auto";
    scrollEl.style.paddingTop = 0;
  };

  var detectIsAutomaticFilters = function detectIsAutomaticFilters() {
    pepFilters.map(function (filter, index) {
      if (!filter.values.length) {
        var newValues = findAvaliableValues(filter.property);
        var newFilters = pepFilters;
        newFilters[index].values = newValues;
        newValues.length ? dispatch((0, _creators.setPepFilters)(newFilters)) : null;
      }
    });
  };

  var findAvaliableValues = function findAvaliableValues(property) {
    var newFiltersList = {};
    pimApi.products.map(function (product) {
      var productValue = product[property];

      if (!newFiltersList[productValue]) {
        newFiltersList[productValue] = {};
        newFiltersList[productValue].label = productValue;
        newFiltersList[productValue].value = productValue;
        newFiltersList[productValue].isSelected = false;
        newFiltersList[productValue].productIDs = [];
      }

      newFiltersList[productValue].productIDs.push(product.productId);
    });
    var newValues = [];
    Object.keys(newFiltersList).map(function (key) {
      return newValues.push(newFiltersList[key]);
    });
    return newValues;
  };

  var getFilters = function getFilters() {
    return (0, _utils.createActiveFilters)(pimApi.getFilters());
  };

  var findProducts = function findProducts(filter, value) {
    var newArr = [];
    pimApi.products.map(function (product) {
      if (product[filter]) {
        product[filter] === true || product[filter] === value || doubleFilter(value, product[filter]) ? newArr.push(product.productId) : null;
      }
    });
    return newArr;
  };

  var doubleFilter = function doubleFilter(value, filter) {
    if (Array.isArray(filter) || value.includes(',')) {
      return String(filter).indexOf(String(value)) > -1 || String(value).indexOf(String(filter)) > -1;
    } else {
      return String(value).indexOf(String(filter)) > -1 && String(filter).indexOf(String(value)) > -1;
    }
  };

  var setPreselectedFilters = function setPreselectedFilters() {
    var newFilters = pepFilters;
    newFilters && newFilters.map(function (pepFilter) {
      var filters = pepFilter.values;
      filters && filters.map(function (filter) {
        filter.productIDs = [];
        filter.productIDs = findProducts(pepFilter.property, filter.value);
      });
    });
    dispatch((0, _creators.setPepFilters)(newFilters));
  };

  var calculateFiltersPosition = function calculateFiltersPosition(scrollTop) {
    var scrollEl = document.querySelector(".filters-container .filters");

    if (scrollEl) {
      var contentHeight = document.querySelector("#content").offsetHeight;
      var maxWidth = document.querySelector(".filters-container").offsetWidth;
      scrollEl.style.maxWidth = isMobile ? "none" : maxWidth + "px";

      if (!isMobile && contentHeight > 1400) {
        var wrapperHeight = document.querySelector("#wrapper").offsetHeight;
        var headerHeight = document.querySelector("#header").offsetHeight;
        var footerHeight = document.querySelector("#footer").offsetHeight;
        var scrollCorrection = 130;
        var stickyMenu = document.querySelector(".sticky-navigation.is-sticky") ? document.querySelector(".sticky-navigation.is-sticky").offsetHeight : false;
        var topPosition = stickyMenu ? "".concat(stickyMenu + 45, "px") : "45px";

        if (scrollTop > scrollEl.offsetHeight && !isMobile) {
          if (wrapperHeight + headerHeight - (footerHeight + scrollEl.offsetHeight) < scrollTop + scrollCorrection) {
            scrollEl.style.position = "fixed";
            var negativePosition = wrapperHeight + headerHeight - (footerHeight + scrollEl.offsetHeight) - scrollTop - scrollCorrection;
            scrollEl.style.top = "".concat(String(negativePosition), "px");
          } else if (scrollEl.style.top != topPosition) {
            scrollEl.style.position = "fixed";
            scrollEl.style.top = topPosition;
          }
        } else if (scrollEl.style.position != "relative") {
          resetFiltersPosition(scrollEl);
        }
      } else {
        resetFiltersPosition(scrollEl);
      }
    }
  };

  var handleChange = function handleChange(evt) {
    var target = evt.target;
    var dataKey = target.getAttribute("data-key");
    var value = target.value;

    if (window.pageYOffset) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }

    if (target.checked !== undefined) {
      if (target.checked) {
        pimApi.setFilter(dataKey, value);
      } else {
        pimApi.unsetFilter(dataKey, value);
      }
    } else {
      pimApi.resetFilter(dataKey);

      if (value !== "0") {
        pimApi.setFilter(dataKey, value);
      }
    }

    setFilterValues();
  };

  var setFilterValues = function setFilterValues() {
    var filteredProducts = pimApi.filteredProducts();
    dispatch((0, _creators.setSelectedFilters)((0, _utils.createActiveFilters)(pimApi.getFilters())));
    dispatch((0, _creators.setActiveProducts)(filteredProducts));
    setFiltersParams(window.location.search);
  };

  var isCustomFilterComponent = function isCustomFilterComponent(filter) {
    return filter.property === "productBrandAndFamily" || filter.property === "productId" && !isAccessoriesList;
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: isOpenFilters ? "active filters-container" : "filters-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "close-filters",
    onClick: function onClick() {
      return dispatch((0, _creators.openFilters)((0, _utils.toggleLayerFunction)(false)));
    }
  }, "\uEAE3"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filters ".concat(isIOS ? "ios" : "")
  }, pepFilters.map(function (filter, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "filter",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "filter__content"
    }, !isCustomFilterComponent(filter) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, filter.label.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
      className: "filter__label",
      tabIndex: 5
    }, filter.label), /*#__PURE__*/_react["default"].createElement(_FilterComponent["default"], {
      filter: filter,
      handleChange: handleChange
    })), isCustomFilterComponent(filter) && /*#__PURE__*/_react["default"].createElement(_CustomFilterComponent["default"], {
      filter: filter,
      handleChange: handleChange
    })));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: isOpenFilters ? "active fixed-button-container" : "fixed-button-container"
  }, /*#__PURE__*/_react["default"].createElement(_ResetFiltersComponent["default"], {
    type: "button"
  }), /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    className: "pep-button bg-m-magenta",
    onClick: function onClick(e) {
      return dispatch((0, _creators.openFilters)((0, _utils.toggleLayerFunction)(false)));
    }
  }, dictionary.see, " ", products ? products.length : "", " ", dictionary.products)));
};

var _default = FiltersListComponent;
exports["default"] = _default;